export default "__VITE_ASSET__D6EqsxiO__"